import {OrderService} from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";

const OrderModule = {
	namespaced: true,
	state: {
		datas: [],
		datum: [],
		address: [],
		sale_channel: [],
		payment_channel: [],
		isLoading:false,
		payment_current_page:1,
		order_current_page:1
	},
	mutations: {
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_DATUM(state, data) {
			state.datum = data;
		},
		SET_ADDRESS(state, data) {
			state.address = data;
		},
		SET_PAYMENT_CHANNEL(state, data) {
			state.payment_channel = data;
		},
		SET_SALE_CHANNEL(state, data) {
			state.sale_channel = data;
		},
		SET_SALE_CHANNEL(state, data) {
			state.sale_channel = data;
		},
		SET_PAYMENT_CURRENT_PAGE(state, data){
			state.payment_current_page = data
		},
		SET_ORDER_CURRENT_PAGE(state, data){
			state.order_current_page = data
		}
	},
	actions: {
		async listDatum({ commit, state }, data) {
			try
			{
				commit("SET_DATUM", []);
				const response = await OrderService.ListOrderDetail(data);
				commit("SET_DATUM", response.data.Datum != null ? response.data.Datum : []);
				console.log(response.data.Datum)
			}
			catch (err)
			{
				console.log(err)
				commit("SET_DATUM", []);
			}
		},
		async listData({ commit, state }, data) {
			state.isLoading = true
			swal.fire({
				title: i18n.t(`processing`),
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });
			try
			{
				const response = await OrderService.ListOrder(data);
				swal.close()
				commit("SET_DATA", response.data != null ? response.data : []);
				state.isLoading = false
			}
			catch (err)
			{
				swal.close()
				console.log(err);
				if (err.response && err.response.data) {
					swal.fire({
					title: i18n.t(err.response.data.Msg),
					text: i18n.t(err.response.data.Cause),
					icon: "error",
					buttonsStyling: false,
					confirmButtonClass: "btn btn-info btn-fill"
					});
				} else {
					swal.fire({
					title: "Error",
					text: "Network error or server unavailable",
					icon: "error",
					buttonsStyling: false,
					confirmButtonClass: "btn btn-info btn-fill"
					});
				}
				commit("SET_DATA", []);
				state.isLoading = false
			}
		},
		async listDataDetailProduct({ commit, state }, data) {
				return OrderService.ListOrderDetailProduct(data);
		},


		async listAddress({ commit, state }, data) {
			try
			{
				const response = await OrderService.ListFullAddress();
				commit("SET_ADDRESS", response.data);
			}
			catch (error)
			{
				commit("SET_ADDRESS", []);
			}
		},

		async listAddressV2({ commit, state }, data) {
			try
			{
				const response = await OrderService.ListFullAddressV2();
				commit("SET_ADDRESS", response.data);
			}
			catch (error)
			{
				commit("SET_ADDRESS", []);
			}
		},


		async listSaleChannel({ commit, state }, data) {
			try
			{
				const response = await OrderService.ListSaleChannel(data);
				commit("SET_SALE_CHANNEL", response.data.Data);
			}
			catch (error)
			{
				commit("SET_SALE_CHANNEL", []);
			}
		},


		async listPaymentChannel({ commit, state }, data) {
			try
			{
				const response = await OrderService.ListPaymentChannel(data);
				commit("SET_PAYMENT_CHANNEL", response.data.Data);
			}
			catch (error)
			{
				commit("SET_PAYMENT_CHANNEL", []);
			}
		},


		GetShippingInfo({ commit, state }, data) {
			return OrderService.GetShippingInfo(data);
		},

		createData({ commit, state }, data) {
			console.log("G")
			return OrderService.CreateOrder(data);
		},

		updateData({ commit, state }, data) {
			return OrderService.UpdateOrder(data.id,data.payload);
		},

		cancelData({ commit, state }, data) {
			// Change status to calcel
			// return OrderService.DeleteOrder(data);
			return OrderService.CancelOrder(data.id,data.payload);
		},

		updatePaymentStatusSuccess({ commit, state }, data) {
			return OrderService.OrderPaymentConfirmSetStatusToAwaitingShipment(data.id,data.payload);
		},
		updatePaymentStatusFail({ commit, state }, data) {
			return OrderService.OrderPaymentConfirmSetStatusToCancelled(data.id,data.payload);
		},

		updateDeleverystatus({ commit, state }, data) {
			return OrderService.ChangeDeliveryStatus(data.id,data.payload);
		},

		updatePackageStatus({ commit, state }, data) {
			return OrderService.ChangePackageStatus(data.id,data.payload);
		},

		updateOrderStatus({ commit, state }, data) {
			return OrderService.ChangeOrderStatus(data.id,data.payload);
		},

		cancelOrder({ commit, state }, data) {
			return OrderService.CancelOrder(data.id,data.payload);
		},

		changeTrackingOrder({ commit, state }, data) {
			return OrderService.ChangeTrackingOrder(data.id,data.payload);
		},
		changeShippingOrder({ commit, state }, data) {
			return OrderService.ChangeShippingOrder(data.id,data.payload);
		},
		checkTrackingOrder({ commit, state }, data) {
			return OrderService.CheckTrackingOrder(data.id,data.payload);
		},


		syncPlatformOrder({ commit, state }, data) {
			return OrderService.SyncPlatformOrder(data);
		},


		setPaymentCurrentPage({ commit, state }, data){
			console.log("set payment page",data)
			commit("SET_PAYMENT_CURRENT_PAGE",data)
		},
		setOrderCurrentPage({ commit, state }, data){
			console.log("set order page",data)
			commit("SET_ORDER_CURRENT_PAGE",data)
		},

		setOrderReturn({ commit, state }, data){
			return OrderService.OrderReturn(data);
		}

	},
	getters: {
		getSaleChannel(state) {
			return state.sale_channel;
		},
		getPaymentChannel(state) {
			return state.payment_channel;
		},
		getAddress(state) {
			return state.address;
		},
		getData(state) {
			return state.datas;
		},
		getDatum(state) {
			return state.datum;
		},
		orderStatus(state){
			return [{
				// 100:$t("order_status_unpaid"),
				// 111:$t("order_status_awaiting_shipme"),
				// 112:$t("order_status_awaitingcollection"),
				// 114:$t("order_status_partiallyshipping"),
				// 121:$t("order_status_intransit"),
				// 122:$t("order_status_delivered"),
				// 130:$t("order_status_completed"),
				// 140:$t("order_status_cancelled"),

			}]
		},
		OrderStatusTableWithAll: function() {
            return [
                { ID: 0, Name: "-- สถานะ --" },
                { ID: 100, Name: i18n.t("order_status_unpaid") },
                { ID: 111, Name: i18n.t("order_status_awaiting_shipment") },
                { ID: 112, Name: i18n.t("order_status_awaitingcollection") },
                { ID: 114, Name: i18n.t("order_status_partiallyshipping") },
                { ID: 121, Name: i18n.t("order_status_intransit") },
                { ID: 122, Name: i18n.t("order_status_delivered") },
                { ID: 130, Name: i18n.t("order_status_completed") },
                { ID: 140, Name: i18n.t("order_status_cancelled") },
                { ID: 141, Name: i18n.t("order_status_returned") },
                { ID: 142, Name: i18n.t("order_status_claimed") },
                { ID: 998, Name: i18n.t("order_status_returning") },
                { ID: 999, Name: i18n.t("order_status_intransit_completed") }
            ];
        },
		OrderStatusTableWithAllPayment: function() {
            return [
                { ID: 0, Name: "-- สถานะทั้งหมด (ตรวจสอบชำระเงินแล้ว) --" },
                { ID: 100, Name: i18n.t("order_status_unpaid") },
                { ID: 111, Name: i18n.t("order_status_awaiting_shipment") },
                { ID: 112, Name: i18n.t("order_status_awaitingcollection") },
                { ID: 114, Name: i18n.t("order_status_partiallyshipping") },
                { ID: 121, Name: i18n.t("order_status_intransit") },
                { ID: 122, Name: i18n.t("order_status_delivered") },
                { ID: 130, Name: i18n.t("order_status_completed") },
                { ID: 140, Name: i18n.t("order_status_cancelled") },
                { ID: 141, Name: i18n.t("order_status_returned") },
                { ID: 142, Name: i18n.t("order_status_claimed") }
            ];
        },
		isLoading(state){
			return state.isLoading
		},
		getPaymentCurrentPage(state) {
			return state.payment_current_page;
		},
		getOrderCurrentPage(state) {
			return state.order_current_page;
		},
		getShippingProvider(state){
            return [
                { id: 1, name: "ไปรษณีย์ไทย" },
                { id: 2, name: "เคอรี่ เอ็กเพรส" },
                { id: 5, name: "DHL" },
                { id: 6, name: "MadameFin" },
                { id: 7, name: "SPX" },


	// ShippingProviderKerry     int64 = 2
	// ShippingProviderNinjaVan  int64 = 3
	// ShippingProviderFlash     int64 = 4
	// ShippingProviderDHL       int64 = 5
	// ShippingProviderMadameFin int64 = 6
	// ShippingProviderXPX int64 = 7
			]
		},
		getPlatformTable(state){
            return [
                { id: 1, name: "มาดามฟิน" },
                { id: 2, name: "Tiktok" },
                { id: 3, name: "Shopee" },
                { id: 4, name: "Lazada" },
                { id: 5, name: "Line" },
                { id: 8, name: "Pancake" },
			]
		},
		getPlatformTableWithAll(state){
            return [
                { id: 0, name: "-- Platform --" },
                { id: 1, name: "มาดามฟิน" },
                { id: 2, name: "Tiktok" },
                { id: 3, name: "Shopee" },
                { id: 4, name: "Lazada" },
                { id: 5, name: "Line" },
                { id: 8, name: "Pancake" },
			]
		}
	},

}

export default OrderModule;
